// ** Reducers Imports
import bids from "@store/bids"
import boms from "@store/boms"
import listManager from "@store/listManager";
import otps from "@store/otps"

import authentication from "./authentication"
import consigneeAuthentication from "./consigneeAuthentication"
import deliveryAuthentication from "./deliveryAuthentication"
import layout from "./layout"
import navbar from "./navbar"

const rootReducer = { navbar, layout, authentication, bids, consigneeAuthentication, listManager, boms, otps,deliveryAuthentication }

export default rootReducer
